export const SMS_LINK = 'SMS_LINK';
export const SMS_CODE = 'SMS_CODE';
export const EMAIL_LINK = 'EMAIL_LINK';
export const EMAIL_CODE = 'EMAIL_CODE';
